export const BUSINESS = {
  name: "Urbina Land Investments",
  legal: "Urbina Land Investments LLC",
  phone: "941-499-6407",
  phoneHref: "tel:9414996407",
  email: "info@urbinalandinvestments.com",
  area: "Based in Florida • Buying Vacant Land Nationwide",
  tagline: "A nationwide land investment company — we buy vacant land directly from owners, for cash.",
};

export const NAV_LINKS = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Available Lots", id: "lots" },
  { label: "How It Works", id: "how" },
  { label: "Reviews", id: "reviews" },
  { label: "Contact", id: "contact" },
];

export const INTENT_OPTIONS = [
  "Sell My Land",
  "Buy Land",
  "Builder Looking for Lots",
  "Investor Looking for Lots",
  "General Question",
];

export const BUDGET_OPTIONS = [
  "Under $25,000",
  "$25,000 – $75,000",
  "$75,000 – $150,000",
  "$150,000 – $300,000",
  "$300,000+",
];

export const TIMELINE_OPTIONS = [
  "As soon as possible",
  "Within 30 days",
  "1 – 3 months",
  "3 – 6 months",
  "Just exploring",
];

export const US_STATES = [
  "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut",
  "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa",
  "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan",
  "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire",
  "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio",
  "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota",
  "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia",
  "Wisconsin", "Wyoming",
];

export const EXCLUDED_STATES = ["Illinois", "Oklahoma", "South Carolina", "Virginia"];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1600399507991-c9f51bc7cc2f?crop=entropy&cs=srgb&fm=jpg&q=80&w=1920&auto=format";

export const WHYUS_IMAGE =
  "https://images.unsplash.com/photo-1758464643876-76d6eb6ea262?crop=entropy&cs=srgb&fm=jpg&q=80&w=1100&auto=format";

// Live inventory. Empty until real parcels are added. No placeholder/sample listings.
export const LOTS = [];

// Genuine client reviews only. Empty until real testimonials are collected. No placeholder reviews.
export const REVIEWS = [];

export const DIFFERENTIATORS = [
  { title: "No Realtor Commissions", desc: "We buy directly — you never pay agent fees or commissions." },
  { title: "Fast Cash Offers", desc: "A straightforward, cash-ready process built to move quickly." },
  { title: "No Listing Fees", desc: "Skip the listing, showings, and drawn-out market timelines." },
  { title: "Direct Negotiation", desc: "You deal with us, owner-to-buyer — clear and straightforward." },
];

export const TRUST_POINTS = [
  { title: "No Realtor Commissions", desc: "Sell directly to us and keep more of your proceeds." },
  { title: "Fast Cash Offers", desc: "Get a fair, no-obligation cash offer without the wait." },
  { title: "Close on Your Timeline", desc: "You choose the closing date that works for you." },
];
